import { Navigate, useLocation } from 'react-router-dom';
import { Spin, Result } from 'antd';
import { useAuth } from '../hooks/useAuth';
import { usePermission } from '../hooks/usePermission';

interface AuthGuardProps {
  children: React.ReactNode;
  /** If provided, requires a specific permission check (client-side display only) */
  requirePermission?: keyof ReturnType<typeof usePermission>;
  /** If true, only super_admin can access */
  requireSuperAdmin?: boolean;
}

export function AuthGuard({ children, requirePermission, requireSuperAdmin }: AuthGuardProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const perms = usePermission();
  const location = useLocation();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireSuperAdmin && !perms.isSuperAdmin) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="您没有权限访问此页面"
      />
    );
  }

  if (requirePermission && !perms[requirePermission]) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="您没有权限访问此页面"
      />
    );
  }

  return <>{children}</>;
}
